'use strict';

var fetchRetry = require('fetch-retry');
var CircuitBreakerManager = require('./CircuitBreakerManager.js');

/* eslint-disable no-console */

async function bonnetFetch(path, {
  query,
  search,
  data,
  circuitBreaker,
  base,
  retries,
  retryOn,
  retryDelay,
  onError,
  ...options
} = {}) {
  // assign localhost as the base if one is not supplied
  if (!base) {
    base = `http://${process.env.BONNET_HOSTNAME}:${process.env.BONNET_PORT}`;
  }

  // allow for relative client requests
  if (typeof window !== 'undefined') {
    base = window.location.origin;
  }
  const url = new URL(path, base);
  const hasQuery = Array.from(url.searchParams.keys()).length > 0;

  // Build a query string
  if (query || search || data) {
    if (hasQuery) {
      throw Error('bonnet fetch will not append query, search, or data to an existing query string');
    } else {
      // Allow service to supply a querystring via query, search, data options
      const newParams = {
        ...query,
        ...search,
        ...data
      };
      Object.entries(newParams).forEach(([key, value]) => url.searchParams.append(key, value));
    }
  }
  const enableRetry = retries || retryOn || retryDelay;
  const fetcher = (...args) => {
    function handleErrors(response) {
      if (!response.ok) {
        console.log(`response from ${url.href} was not ok`, response);
        return Promise.reject(response);
      }
      return response;
    }
    return fetch(...args).then(handleErrors)
    // eslint-disable-next-line consistent-return
    .catch(err => {
      // err can be a rejected promise with a failed response from handleErrors(above) or network error
      console.error(err);
      if (typeof onError === 'function') {
        onError(err);
      }
      if (circuitBreaker) {
        return Promise.reject(err); // throw rejected promise to circuitbreaker to trip
      }
      if (enableRetry) {
        if (err && err.status) {
          return err; // resolve failed response to further retry
        }
        return Promise.reject(err); // reject network error to further retry
      }
    });
  };
  let fetchBuilder = fetcher;
  if (circuitBreaker) {
    const breaker = await CircuitBreakerManager.getCircuitBreaker(fetcher, url, circuitBreaker);
    fetchBuilder = (...args) =>
    // eslint-disable-next-line
    breaker.fire(...args).catch(error => {
      console.log(`Failed breaker call to ${args[0]}`, error);
      if (enableRetry) {
        if (error && error.status) {
          return error; // resolve failed response to further retry
        }
        return Promise.reject(error); // reject network error to further retry
      }
    });
  }

  // wrap with fetch-retry
  // https://github.com/jonbern/fetch-retry
  if (enableRetry) {
    return fetchRetry(fetchBuilder, {
      ...(retries && {
        retries
      }),
      ...(retryOn && {
        retryOn
      }),
      ...(retryDelay && {
        retryDelay
      })
    })(url.href, options);
  }
  return fetchBuilder(url.href, options);
}

exports.bonnetFetch = bonnetFetch;
